module.exports = __webpack_public_path__ + "img/Caret-Up_Filled_16px_Icon-red.c51663f9.svg";